import Api from '@/services/Api'

export default {
	getAllNotas(codReporte){
		return Api().get('/notas/getAllNotas/'+codReporte)
	},
	getNotaById(id){
		return Api().get('/notas/getNotaById/'+id)
	},
	createNota(formu){
		return Api().post('/notas/createNota',formu)
	},
	updateNota(info){
		return Api().put('/notas/updateNota',info)
	},
	deleteNota(id,codReporte,numero){
		return Api().get('/notas/deleteNota/'+id+'/'+codReporte+'/'+numero)
	},
	createParrafo(formData){
		return Api().post('/notasParrafo/create',formData)
	},
	updateParrafo(formData){
		return Api().post('/notasParrafo/update',formData)
	},
	deleteParrafo(codReporte, numero, parrafo, vigencia, idCompania){
		return Api().delete('/notasParrafo/delete/' + codReporte + '/' + numero + '/' + parrafo + '/' + vigencia + '/' + idCompania);
	},
	grabeNiifNota(id,nota,u_modifica) {
		let datos = {}
		datos.nota=nota
		datos.u_modifica=u_modifica
		return Api().put('/notas/grabeNiifNotas/'+id,datos)
	},
	leaNiifNotas(vigencia,codReporte) {
		return Api().get('/notas/leaNiifNotas/'+vigencia+'/'+codReporte)
	}
}
